<script setup>
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();

// Helper function to handle fallbacks when translations return the key itself
const tWithFallback = (key, fallback) => {
  const translation = t(key);
  return translation === key ? fallback : translation;
};
</script>

<template>
  <div class="rounded-lg contact-us shadow-gradient">
    <div class="grid grid-cols-1 gap-4 md:gap-6 lg:gap-8 md:grid-cols-2">
      <!-- Contact Information (Left Column) -->
      <div class="p-4 sm:p-5 md:p-6 contact-info">
        <h2 class="mb-4 text-xl font-semibold">
          {{
            tWithFallback("footer.contactInfo.title", "Informasi Kontak Kami")
          }}
        </h2>

        <div class="mb-6">
          <h3 class="mb-2 font-semibold">
            {{ tWithFallback("footer.contactInfo.address.title", "Alamat:") }}
          </h3>
          <p>
            {{
              tWithFallback(
                "footer.contactInfo.address.faculty",
                "Fakultas Ekonomi dan Bisnis"
              )
            }}
          </p>
          <p>
            {{
              tWithFallback(
                "footer.contactInfo.address.university",
                "Universitas Negeri Gorontalo"
              )
            }}
          </p>
          <p>
            {{
              tWithFallback(
                "footer.contactInfo.address.street",
                "Jl. Jend Sudirman Nomor .06"
              )
            }}
          </p>
          <p>
            {{
              tWithFallback(
                "footer.contactInfo.address.city",
                "Kota Gorontalo, Gorontalo"
              )
            }}
          </p>
        </div>
        <div class="mb-6">
          <h3 class="mb-2 font-semibold">
            {{ tWithFallback("footer.contactInfo.email.title", "Email:") }}
          </h3>
          <p>fe@ung.ac.id</p>
        </div>
        <div class="mb-6">
          <h3 class="mb-2 font-semibold">
            {{
              tWithFallback(
                "footer.contactInfo.workingHours.title",
                "Jam Kerja:"
              )
            }}
          </h3>
          <p>
            {{
              tWithFallback(
                "footer.contactInfo.workingHours.weekdays",
                "Senin - Jumat: 08:00 WITA - 16:30 WITA"
              )
            }}
          </p>
          <p>
            {{
              tWithFallback(
                "footer.contactInfo.workingHours.weekend",
                "Sabtu - Minggu: Tutup"
              )
            }}
          </p>
        </div>
      </div>

      <!-- Google Maps (Right Column) -->
      <div class="p-4 sm:p-5 md:p-6 map-container">
        <h2 class="mb-4 text-xl font-semibold">
          {{ tWithFallback("footer.contactInfo.findUs", "Temukan kami") }}
        </h2>
        <div class="overflow-hidden rounded-lg google-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997.1343249449051!2d123.06190506955117!3d0.5539947994044439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x32792b5a7dfbbf23%3A0x418b911c7356e7db!2sFakultas%20Ekonomi%20UNG!5e0!3m2!1sid!2sid!4v1721201329047!5m2!1sid!2sid"
            style="border: 0; width: 100%; height: 100%"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.contact-us {
  width: 100%;
  position: relative;
  background-color: white;
  border: 1px solid #f0f0f0;
}

.shadow-gradient {
  box-shadow: 0 4px 6px -1px rgba(128, 0, 0, 0.1),
    0 2px 4px -1px rgba(128, 0, 0, 0.06), 0 0 0 3px rgba(255, 215, 0, 0.1),
    0 0 20px 4px rgba(184, 134, 11, 0.15);
}

.shadow-gradient:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #ffd700, #800000);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.contact-info p {
  margin-bottom: 0.5rem;
  color: #4a4a4a;
}

.contact-info h3 {
  color: #800000; /* maroon color for headings */
}

.contact-info h2,
.map-container h2 {
  color: #b8860b; /* dark golden color for main headings */
}

.google-map {
  width: 100%;
  height: 100%;
  min-height: 300px;
  border: 1px solid #f0f0f0;
}

/* Responsive adjustments */
@media (min-width: 768px) {
  .google-map {
    min-height: 350px;
  }
}

@media (min-width: 1024px) {
  .google-map {
    min-height: 380px;
  }
}

/* Match height to content */
@media (min-width: 768px) {
  .grid {
    align-items: stretch;
  }
  .map-container,
  .contact-info {
    display: flex;
    flex-direction: column;
  }
  .google-map {
    flex-grow: 1;
  }
}
</style>
